import type { TDatadogErrorLog } from 'utils/datadog/types'

export const PAGINATION_LIMIT = 10

export const LOAD_DASHBOARD_LIST_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/create-dashboard-folder-modal',
  name: 'Loads Dashboard list',
  message: 'Failed to load the Dashboard list',
}

export const CREATE_DASHBOARD_FOLDER_LOG: TDatadogErrorLog = {
  from: 'src/modules/dashboard/create-dashboard-folder-modal',
  name: 'Creates dashboard folder',
  message: 'Failed to create dashboard folder',
}
